const MENU_CURATION_TASK_AWAITING_STATUS = {
  CURATION_PENDING: 'CURATION_PENDING',
  CURATION_ERROR: 'CURATION_ERROR',
  IMPORT_PENDING: 'IMPORT_PENDING',
  IMPORT_ERROR: 'IMPORT_ERROR',
  DUPLICATE_PENDING: 'DUPLICATE_PENDING',
  DUPLICATE_ERROR: 'DUPLICATE_ERROR',
}

module.exports = MENU_CURATION_TASK_AWAITING_STATUS
